/**
 * Pagination
 */

// Module dependencies
import 'protons';
import 'atoms/svg';

// Module template
import './_pagination.twig';

// Module styles
import './_pagination.scss';

export const name = 'pagination';

export function disable() {}

export function enable() {}

export default enable;
